"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Spinner.css");
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        this.userMessage = this.props.data.usrDefMsg;
        var isFixedProp = false;
        if (this.props.options && this.props.options.isFixed) {
            isFixedProp = this.props.options.isFixed;
        }
        return (React.createElement("div", { "data-test-id": this.props.testId },
            React.createElement("div", { className: styles.iconSpinnerHolder },
                this.getOverlay(),
                React.createElement("div", { className: (isFixedProp) ? styles.iconSpinnerHolderFxd + ' ' + styles.moveTop : styles.moveTop },
                    React.createElement("svg", { viewBox: "0 0 43 43", className: styles.loadingSpinner, "aria-labelledby": "title" },
                        React.createElement("title", { id: "title" }, (this.props.options && this.props.options.accessibilityText) || 'Please wait image'),
                        React.createElement("g", null,
                            React.createElement("circle", { className: styles.loadingSpinnerInner, r: "19.5", cx: "21.5", cy: "21.5", fill: "none" }),
                            React.createElement("circle", { className: styles.loadingSpinnerOuter, r: "19.5", cx: "21.5", cy: "21.5", fill: "none" }))),
                    React.createElement("br", null),
                    this.userMessage,
                    "..."))));
    };
    Spinner.prototype.getOverlay = function () {
        if (this.props.options && this.props.options.showOverlay) {
            return React.createElement("div", { className: styles.spinnerOverlay });
        }
    };
    return Spinner;
}(React.Component));
exports.default = Spinner;
//# sourceMappingURL=Spinner.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Spinner/Spinner.js
// module id = 1255
// module chunks = 8